export const entityNames = {
	floor: "Grid",
} as const;
